function syncOneClickForm(form, productContainer) {
	if (!form || !productContainer) {
		return;
	}

	const productIdInput = form.querySelector('[name="product_id"]');
	const selectorsContainer = form.querySelector('[data-one-click-selectors]');

	if (productIdInput) {
		productIdInput.value = productContainer.dataset.id || '';
	}

	if (!selectorsContainer) {
		return;
	}

	selectorsContainer.innerHTML = '';

	productContainer.querySelectorAll('.form-selector .radio-elem:checked').forEach((input) => {
		const hiddenInput = document.createElement('input');
		hiddenInput.type = 'hidden';
		hiddenInput.name = input.name;
		hiddenInput.value = input.value;
		selectorsContainer.appendChild(hiddenInput);
	});
}

listener('click', '[data-vg-toggle="prd-sidebar"]', (el, event) => {
	event.preventDefault();

	const container = el.closest('.modal-body');
	const productContainer = el.closest('[data-product-modal], [data-product]');
	const form = container ? container.querySelector('[data-one-click-form]') : null;

	syncOneClickForm(form, productContainer);
	container.classList.add('active-one-click');
});

listener('click', '[data-vg-dismiss="prd-sidebar"]', (el, event) => {
	event.preventDefault();

	const container = el.closest('.modal-body');
	container.classList.remove('active-one-click');
});

listener('click', '#catalog-product-show .modal-body-background', (el, event) => {
	event.preventDefault();

	const container = el.closest('.modal-body');
	container.classList.remove('active-one-click');
});

listener('click', '[data-bs-target="#modal-one-click"]', (el) => {
	const productContainer = el.closest('[data-product-modal], [data-product]');
	const target = document.querySelector('#modal-one-click');
	const form = target ? target.querySelector('[data-one-click-form]') : null;

	syncOneClickForm(form, productContainer);
});

document.addEventListener('submit', (event) => {
	const form = event.target.closest('[data-one-click-form]');

	if (!form) {
		return;
	}

	const productContainer = form.closest('[data-product-modal], [data-product]') || document.querySelector('#modal-one-click.show [data-product], #modal-prd-add.show [data-product-modal]');

	syncOneClickForm(form, productContainer);
}, true);


document.addEventListener('DOMContentLoaded', (event) => {
	$('#modal-prd-add').on('hidden.bs.modal', function (event) {
		$(this).find('.modal-body').removeClass('active-one-click');
	})
})
